import { TextFieldProps } from "@mui/material"
import React, { FormEvent, KeyboardEvent } from "react"
import styled, { ThemeProvider } from "styled-components"
import { CommonPopperProps } from "./CommonPopperProps"
import { Popper } from "./Popper"
import { PopperSaveButton } from "./PopperSaveButton"
import { PopperTextInput } from "./PopperTextInput"
import { PopperDarkTheme, PopperLightTheme } from "./popperThemes"

export type TextFieldPopperProps = Omit<TextFieldProps, "onChange"> &
  CommonPopperProps & {
    inputLabel?: string
    onChange: (newValue: string) => void
    onSubmit?: () => Promise<void> | void
  }

export const TextFieldPopper = (props: TextFieldPopperProps) => {
  const {
    popperTitle,
    inputLabel,
    onChange,
    onSubmit,
    onClose,
    onDelete,
    required = false,
    className,
    lightMode = false,
    anchorEl,
    anchorOrigin,
    transformOrigin,
    confirmText,
    ...textFieldProps
  } = props

  const handleSubmit = (e: React.MouseEvent<Element, MouseEvent> | FormEvent) => {
    e.preventDefault()
    onSubmit && onSubmit()
  }

  const handleKeyPress = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === "Enter") handleSubmit(e)
  }

  return (
    <ThemeProvider theme={lightMode ? PopperLightTheme : PopperDarkTheme}>
      <Popper
        title={popperTitle}
        onClose={onClose}
        onDelete={required ? undefined : onDelete}
        anchorEl={anchorEl}
        className={className}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        <PopperTextInputForm>
          <PopperTextInput
            autoFocus
            {...textFieldProps}
            onKeyPress={handleKeyPress}
            onChange={(e) => onChange(e.target.value)}
            variant="outlined"
            label={inputLabel}
            $lightMode={lightMode}
          />

          <CustomSaveButton onClick={handleSubmit} data-cy="saveBtn">
            {confirmText}
          </CustomSaveButton>
        </PopperTextInputForm>
      </Popper>
    </ThemeProvider>
  )
}

const PopperTextInputForm = styled.div`
  position: relative;
`

const CustomSaveButton = styled(PopperSaveButton)`
  width: unset;
  margin-top: 0;
  position: absolute;
  top: 6px;
  right: 8px;
`
